export default "__VITE_ASSET__1Iyn3ExR__"